module.exports = __webpack_public_path__ + "static/media/promo_10.d8d33ffe.svg";